function collectErrorLines(body) {
  const parts = [];
  if (body?.message) parts.push(String(body.message));
  if (body?.step && body.message && !String(body.message).includes(`[${body.step}]`)) {
    parts[0] = `[${body.step}] ${parts[0] || body.message}`;
  }
  if (Array.isArray(body?.errors)) {
    for (const item of body.errors) {
      const text = typeof item === 'string' ? item : item?.error || item?.message;
      if (text && !parts.includes(text)) parts.push(String(text));
    }
  }
  if (body?.field && body.message && !String(body.message).includes(body.field)) {
    parts.unshift(`${body.field}: ${body.message}`);
  }

  const debugIssues = body?.issues || body?.debug?.issues || [];
  if (Array.isArray(debugIssues)) {
    for (const item of debugIssues.slice(0, 12)) {
      const lines = [
        [
          item.rowNumber != null ? `Row ${item.rowNumber}` : null,
          item.userId || null,
          item.step ? `[${item.step}]` : null,
          item.host ? `${item.host}${item.port ? `:${item.port}` : ''}` : null,
        ]
          .filter(Boolean)
          .join(' '),
        item.error || item.message || null,
        item.command ? `cmd: ${item.command}` : null,
        item.stderr ? `stderr: ${item.stderr}` : null,
      ].filter(Boolean);
      const block = lines.join('\n');
      if (block && !parts.includes(block)) parts.push(block);
    }
  }

  const users = body?.sms?.users || body?.debug?.users || [];
  for (const user of users) {
    const fails = (user.steps || []).filter((s) => s && s.ok === false);
    for (const step of fails.slice(-3)) {
      const block = [
        `${user.userId || user.emailId || 'user'} FAIL [${step.step}]`,
        step.detail,
        step.command ? `cmd: ${step.command}` : null,
        step.stderr ? `stderr: ${step.stderr}` : null,
      ]
        .filter(Boolean)
        .join('\n');
      if (block && !parts.includes(block)) parts.push(block);
    }
  }

  return parts;
}

export async function readPmaApiError(err, fallback = 'PMA request failed') {
  const data = err?.response?.data;
  let body = data;

  if (typeof Blob !== 'undefined' && data instanceof Blob) {
    try {
      body = JSON.parse(await data.text());
    } catch {
      body = null;
    }
  }

  if (typeof body === 'string' && body.trim()) return body.trim();

  const parts = collectErrorLines(body);
  if (parts.length) return parts.join('\n\n');
  if (err?.message && err.message !== 'Request failed with status code 400') return err.message;
  return fallback;
}

/** Prefer structured create response when the API returned partial debug on error. */
export function readPmaCreateFailurePayload(err) {
  const data = err?.response?.data;
  if (!data || typeof data !== 'object' || data instanceof Blob) return null;
  if (data.debug?.users || data.debug?.issues || data.sms || data.issues || data.report) {
    return {
      message: data.message,
      issues: data.issues || data.debug?.issues || [],
      report: data.report || data.sms?.report || null,
      sms: data.sms || {
        message: data.message,
        users: data.debug?.users || [],
        issues: data.issues || data.debug?.issues || [],
        report: data.report || null,
        successCount: 0,
        errorCount: (data.issues || data.debug?.issues || data.errors || []).length,
      },
      debug: data.debug || null,
    };
  }
  return null;
}
